// extracted by mini-css-extract-plugin
export var container = "RightSideSection-module--container--O-hIe";